<template>
    <div>
        <div class="container pb-5 container-mob" >
            <div class="row">
                <div class="text-center col-lg-12 pb-3">
                    <h1 class="section-head">{{news['title_'+selectedLocale.suffix.toLowerCase()]}}</h1>
                </div>
                <div class="text-justify">
                    <img class="inner_news_image" :src="(news.image) ? '/static/uploads/'+news.image : '/static/images/no_image.jpg'">
                    <p v-html="news['body_' + selectedLocale.suffix.toLowerCase()]"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import {getNewsId} from '../api/index'
    export default {
        name: 'news-detail',
        data() {
            return {
                news: {},
                index: null,
            }
        },
        computed: {
            ...mapGetters(["selectedLocale"])
        },
        mounted() {
            this.getData()
        },
        methods: {
            getData() {
                getNewsId(  this.$route.params.id).then(res => {
                    this.news = (res.data.length) ? res.data[0] : {}
                })
            }
        }
    }
</script>

<style>
    .inner_news_image {
        float: left;
        width: 100%;
        margin: 0 20px 10px 0;
        height: 480px;
    }
    .realized_images .vueperslides__parallax-wrapper {
        padding-bottom: 20% !important;
    }
    .blueimp-gallery a {
        color: white !important;
    }
    .realized_img  {
        width: 268px;
        height: 178px;
    }
    .realized_img img {
        width: 100%;
        height: 100%;
        vertical-align: center;
    }
    .container-mob {
        padding-top: 100px;
    }
</style>
